(function () {
	'use strict';

	a3_cabin_reports.controller('IncompleteServicesIssueCtrl', IncompleteServicesIssueCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name IncompleteServicesIssueCtrl
    * @description 
    *  Manages the Special Modal View
    * @ngInject
    */
	function IncompleteServicesIssueCtrl($scope, $uibModalInstance, ModalDialogResultFactory, IncompleteServicesIssueFactory, IncompleteServicesSourceFactory, service, fleetId) {
		// setup available reasons and services
		var a3Reasons = IncompleteServicesSourceFactory.getA3ReasonsFromStorage();
		var oaReasons = IncompleteServicesSourceFactory.getOAReasonsFromStorage();
		var a3Services = IncompleteServicesSourceFactory.getA3ServicesFromStorage();
		var oaServices = IncompleteServicesSourceFactory.getOAServicesFromStorage();
		if (!(a3Reasons instanceof Array)) a3Reasons = [];
		if (!(oaReasons instanceof Array)) oaReasons = [];
		if (!(a3Services instanceof Array)) a3Services = [];
		if (!(oaServices instanceof Array)) oaServices = [];
		if(fleetId == 1){
			$scope.availableReasons = a3Reasons;
			$scope.availableServices = a3Services;
		}else{
			$scope.availableReasons = oaReasons;
			$scope.availableServices = oaServices;
		}
		//Both:
		// $scope.availableReasons = a3Reasons.concat(oaReasons).unique();
		// $scope.availableServices = a3Services.concat(oaServices).unique();

		var result = ModalDialogResultFactory.createNew();

		if (service == null) {
			result.Object = IncompleteServicesIssueFactory.createNew();
			result.isInsertMode = true;
		} else {
			result.Object = IncompleteServicesIssueFactory.fromObject(service);
			result.isInsertMode = false;
		}

		$scope.service = result.Object;
		$scope.service.ServiceClass = $scope.service.ServiceClass == null ? 'Y' : $scope.service.ServiceClass;

		$scope.ok = ok;
		$scope.cancel = cancel;
		$scope.clearIncompleteServiceRemarks = clearIncompleteServiceRemarks;
        
        $scope.addRows = addRows;
        $scope.removeRow = removeRow;
        
        function removeRow(index){
            $scope.service.Rows.splice(index, 1);
        }
        
        function addRows(){
            var RowSet = { From : null , To : null };
            $scope.service.Rows.push(RowSet);
        }
        
        /**
         * Clear Field
         * @memberof IncompleteServicesIssueCtrl
         */
		function clearField(target, fieldName) {
			if (target[fieldName] == null || target[fieldName] == '') return false;
			bootbox.dialog({
				message: "Please confirm that you wish to clear this field",
				title: "<strong>Attention<strong>",
				buttons: {
					cancel: {
						label: "Cancel",
						className: "btn-default",
						callback: function () { }
					},
					ok: {
						label: "Ok",
						className: "btn-warning",
						callback: function () {
							target[fieldName] = null;
							$scope.$apply();
							return true;
						}
					}
				}
			});
		}


        /**
         * Clear Special Meal Issue remarks
         * @memberof SpecialMealIssueCtrl
         */
		function clearIncompleteServiceRemarks(service) {
			clearField(service, "Remarks");
			//sup.Remarks = null;
		}

        /**
         * set date and close modal
         * @memberof SpecialMealIssueCtrl
         */
		function ok() {
			var test = $scope.service;

			$uibModalInstance.close(result);
		}

        /**
         * Close modal after u check position
         * @memberof SpecialMealIssueCtrl
         */
		function cancel() {
			$uibModalInstance.close(null);
		}



	}

})();
